import { Stack, Typography } from "@mui/material";
import { executionLogsSourceNames } from "@/components/pages/execution-log/utils/constants/common";
import { connectSourceAndExecutedByaFilterValue } from "@/components/pages/execution-log/utils/helpers/getSourceAndExecutedByFromSelectValues";

export const getExecutionLogSourceFilterOption = (
  name?: string | null,
  source?: string | null,
  value?: string,
) => {
  const generatedValue = connectSourceAndExecutedByaFilterValue(
    source ?? "",
    name ?? "",
  );

  return {
    value: value ?? generatedValue,
    label: (
      <Stack>
        <Typography variant="body2">{name}</Typography>

        {source && source !== "manual" && (
          <Typography variant="caption" color="text.disabled">
            {executionLogsSourceNames.get(source)}
          </Typography>
        )}
      </Stack>
    ),
  };
};
